import { Icon } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import * as Styled from "./style";
import { useRouter } from "next/router";
import { NextLink } from "~/components/blocks/common/next-link";
import { getParentDir } from "~/components/blocks/layout/global-navi/util/getParentDir";
import { PATHS } from "~/const/paths";

export const VideoMenuItem = memo(() => {
  const { asPath } = useRouter();
  const videoMenuIsActive = asPath.startsWith(getParentDir(PATHS.VOD));

  return (
    <Styled.LIList isActive={videoMenuIsActive}>
      <NextLink href={PATHS.VOD}>
        <Styled.DivItem isActive={videoMenuIsActive}>
          <Icon name={videoMenuIsActive ? "play" : "outlinePlay"} size="XL" />
          ビデオ
        </Styled.DivItem>
      </NextLink>
    </Styled.LIList>
  );
});

VideoMenuItem.displayName = "VideoMenuItem";
